"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const utils_common_get_url_params_1 = __importDefault(require("@gcloud-npm/utils.common.get-url-params"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_redux_1 = require("react-redux");
const utils_secure_local_storage_1 = __importDefault(require("@gcloud-npm/utils.secure.local-storage"));
const utils_common_is_webview_1 = __importDefault(require("@gcloud-npm/utils.common.is-webview"));
const utils_common_is_colapp_1 = __importDefault(require("@gcloud-npm/utils.common.is-colapp"));
const reducers_main_reducer_1 = require("@/bit/reducers/reducers.main-reducer");
const create_initial_object_1 = __importDefault(require("./create-initial-object"));
const utils_common_get_cookie_1 = __importDefault(require("@gcloud-npm/utils.common.get-cookie"));
const get_geo_1 = __importDefault(require("./get-geo"));
const utils_page_get_optanon_cookie_info_1 = __importDefault(require("@gcloud-npm/utils.page.get-optanon-cookie-info"));
const get_eg_1 = __importDefault(require("./get-eg"));
const get_recom_1 = __importDefault(require("./get-recom"));
const get_notifications_1 = __importDefault(require("./get-notifications"));
const workers_1 = require("./get-notifications/services/workers");
const refresh_secure_1 = __importDefault(require("./refresh-secure"));
const utils_common_set_cookie_onetrust_handled_1 = __importDefault(require("@gcloud-npm/utils.common.set-cookie-onetrust-handled"));
const utils_secure_secure_object_2_perso_cookie_1 = require("@gcloud-npm/utils.secure.secure-object-2-perso-cookie");
const WEBVIEW_CONSENT_RETRIES = 10;
const WEBVIEW_CONSENT_RETRY_DELAY_MS = 100;
const NOTIFICATIONS_REFRESH_EVENT = "gcloud:notifications:refresh";
const NOTIFICATIONS_RESET_EVENT = "gcloud:notifications:reset";
const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const normalizeConsentStatus = (status) => {
    if (status && typeof status === "object" && typeof status.status !== "undefined") {
        return status.status;
    }
    return status;
};
const castToConsentState = (status) => {
    if (status === "granted" || status === "denied") {
        return status;
    }
    if (status === true || status === "1" || status === 1) {
        return "granted";
    }
    if (status === false || status === "0" || status === 0) {
        return "denied";
    }
    return status;
};
const isFinalConsentState = (status) => status === "granted" || status === "denied";
const getOptanonCookieInfoWebview = ({ webviewOrigin = "" }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    let optanon = (0, utils_common_get_cookie_1.default)("OptanonConsent") || "";
    try {
        optanon = decodeURIComponent(optanon);
    }
    catch (e) { }
    let ad_storage = optanon && optanon.indexOf("C0004:1") !== -1 ? "granted" : "denied";
    let analytics_storage = optanon && optanon.indexOf("C0002:1") !== -1 ? "granted" : "denied";
    let ad_user_data = ad_storage;
    let ad_personalization = ad_storage;
    for (let retry = 0; retry < WEBVIEW_CONSENT_RETRIES; retry += 1) {
        if (webviewOrigin) {
            let status = null;
            if (webviewOrigin === "novum" && ((_a = window === null || window === void 0 ? void 0 : window.webviewBridge) === null || _a === void 0 ? void 0 : _a.getAttStatus)) {
                try {
                    status = yield window.webviewBridge.getAttStatus();
                }
                catch (e) { }
            }
            else if (webviewOrigin === "col-app" &&
                ((_b = window === null || window === void 0 ? void 0 : window.manhattanBridge) === null || _b === void 0 ? void 0 : _b.getConsent)) {
                try {
                    const { analyticsAllowed, adsAllowed } = yield window.manhattanBridge.getConsent();
                    const analyticsConsentState = castToConsentState(analyticsAllowed);
                    const adsConsentState = castToConsentState(adsAllowed);
                    if (isFinalConsentState(analyticsConsentState) && isFinalConsentState(adsConsentState)) {
                        ad_storage = adsConsentState;
                        analytics_storage = analyticsConsentState;
                        ad_user_data = adsConsentState;
                        ad_personalization = adsConsentState;
                        return {
                            ad_storage,
                            analytics_storage,
                            ad_user_data,
                            ad_personalization,
                        };
                    }
                }
                catch (e) {
                    console.warn("It works under an specific webview, dont worry if you are mocking environment, col-app");
                }
            }
            else {
                // intentamos leer de url en web para casos raros recuperacion contraseñas
                try {
                    const attUrlParams = (0, utils_common_get_url_params_1.default)({ groupByObject: false, allowedParams: false, excludeHash: false, currentUrl: window.location.href, });
                    status = attUrlParams.att;
                    const normalizedStatus = normalizeConsentStatus(status);
                    const consentState = castToConsentState(normalizedStatus);
                    if (consentState != null) {
                        // cogemos el valorcito, sino me quedo los que ya
                        ad_storage = consentState;
                        analytics_storage = consentState;
                        ad_user_data = consentState;
                        ad_personalization = consentState;
                        return {
                            ad_storage,
                            analytics_storage,
                            ad_user_data,
                            ad_personalization,
                        };
                    }
                }
                catch (e) {
                    console.error("Could not read att from url params");
                }
            }
            const normalizedStatus = normalizeConsentStatus(status);
            const consentState = castToConsentState(normalizedStatus);
            if (isFinalConsentState(consentState)) {
                ad_storage = consentState;
                analytics_storage = consentState;
                ad_user_data = consentState;
                ad_personalization = consentState;
                return {
                    ad_storage,
                    analytics_storage,
                    ad_user_data,
                    ad_personalization,
                };
            }
        }
        yield wait(WEBVIEW_CONSENT_RETRY_DELAY_MS);
    }
    return {
        ad_storage,
        analytics_storage,
        ad_user_data,
        ad_personalization,
    };
});
class RouteHandler extends react_1.Component {
    constructor(props) {
        super(props);
        this.runRouteLanding = () => __awaiter(this, void 0, void 0, function* () {
            const { context, checkCPAndSetZones, setCpParams, setUserPqInfo, setUserDefinitions, setUserCompatibilities, setUserPromotions, setUserBundle, setUserLgInfo, setUserPoInfo, setUserRecom, setCustomer, setContextData, isReactApp, addNotifications, } = this.props;
            const secureStorage = new utils_secure_local_storage_1.default();
            const persistedInfo = secureStorage.getItem("ts");
            // 1) Miramos estado cookies
            let { ad_storage, analytics_storage, ad_user_data, ad_personalization } = {};
            let webviewOrigin = "";
            if ((0, utils_common_is_colapp_1.default)()) {
                webviewOrigin = 'col-app';
            }
            else if ((0, utils_common_is_webview_1.default)()) {
                webviewOrigin = 'novum';
            }
            if (webviewOrigin) {
                ({ ad_storage, analytics_storage, ad_user_data, ad_personalization } = yield getOptanonCookieInfoWebview({ webviewOrigin }));
            }
            else {
                ({ ad_storage, analytics_storage, ad_user_data, ad_personalization } = (0, utils_page_get_optanon_cookie_info_1.default)());
            }
            (0, utils_common_set_cookie_onetrust_handled_1.default)({ perso: (ad_personalization == 'granted') });
            (0, utils_secure_secure_object_2_perso_cookie_1.setPersoCookieUsing)(persistedInfo);
            // 2) Creamos context para main en redux y enviamos a GA
            (0, create_initial_object_1.default)({
                context,
                setUserPqInfo,
                setUserCompatibilities,
                setUserPromotions,
                setUserBundle,
                setUserDefinitions,
                setUserLgInfo,
                setUserPoInfo,
                setContextData,
                setUserRecom,
                setCustomer,
                ad_storage,
                analytics_storage,
                ad_user_data,
                ad_personalization,
                isReactApp,
                onEnd: (params) => {
                    this.lastNotificationParams = Object.assign(Object.assign({}, params), { addNotifications });
                    return (0, get_notifications_1.default)(this.lastNotificationParams);
                },
            });
            // 3) Persistimos geo
            (0, get_geo_1.default)({
                persistedInfo,
                checkCPAndSetZones,
                setCpParams,
                // necesito cookies para hacer lo que debemos
                ad_storage,
                analytics_storage,
            });
            // 4) Persistimos getRecom
            (0, get_recom_1.default)({
                persistedInfo,
                setUserRecom,
                ad_storage,
                analytics_storage,
                setUserPqInfo,
            });
            // 5) Persistimos getEg
            (0, get_eg_1.default)({ persistedInfo, context });
            // 6) Comprobamos refresco secure
            (0, refresh_secure_1.default)({ persistedInfo });
        });
        this.handleRouteLanding = () => __awaiter(this, void 0, void 0, function* () {
            if (this.routeLandingPromise) {
                this.routeLandingQueued = true;
                return this.routeLandingPromise;
            }
            const currentRunPromise = this.runRouteLanding();
            this.routeLandingPromise = currentRunPromise;
            try {
                yield currentRunPromise;
            }
            finally {
                if (this.routeLandingPromise === currentRunPromise) {
                    this.routeLandingPromise = null;
                }
            }
            if (this.routeLandingQueued) {
                this.routeLandingQueued = false;
                return this.handleRouteLanding();
            }
            return currentRunPromise;
        });
        this.hasNotificationsInState = () => {
            const notificationsState = this.props.notificationsState || {};
            const notificationList = Array.isArray(notificationsState.notificationList)
                ? notificationsState.notificationList
                : [];
            const notifications = notificationsState.notifications || {};
            const hasNotificationsByType = Object.values(notifications).some((noti) => Array.isArray(noti === null || noti === void 0 ? void 0 : noti.notifications) && noti.notifications.length > 0);
            return notificationList.length > 0 || hasNotificationsByType;
        };
        this.handleNotificationsRefresh = () => __awaiter(this, void 0, void 0, function* () {
            if (this.notificationsRefreshInFlight) {
                return;
            }
            if (this.hasNotificationsInState()) {
                return;
            }
            if (!this.lastNotificationParams) {
                console.log("[notifications-worker] refresh skipped: no previous params");
                return;
            }
            this.notificationsRefreshInFlight = true;
            try {
                yield (0, get_notifications_1.default)(Object.assign(Object.assign({}, this.lastNotificationParams), { skipCache: true }));
            }
            finally {
                this.notificationsRefreshInFlight = false;
            }
        });
        this.handleNotificationsReset = () => {
            this.lastNotificationParams = null;
            this.notificationsRefreshInFlight = false;
            (0, workers_1.releaseWorkerInstance)(undefined, "logout_reset");
            this.props.addNotifications({
                notifications: {},
                notificationList: [],
                unreadNotifications: [],
                finish: true,
            });
        };
        RouteHandler.__singletonRef = this;
        this.routeLandingPromise = null;
        this.routeLandingQueued = false;
        this.lastNotificationParams = null;
        this.notificationsRefreshInFlight = false;
    }
    componentDidMount() {
        if (typeof window !== "undefined") {
            window.addEventListener(NOTIFICATIONS_REFRESH_EVENT, this.handleNotificationsRefresh);
            window.addEventListener(NOTIFICATIONS_RESET_EVENT, this.handleNotificationsReset);
        }
        const { isReactApp } = this.props;
        if (!isReactApp) {
            this.handleRouteLanding();
        }
    }
    componentWillUnmount() {
        if (typeof window !== "undefined") {
            window.removeEventListener(NOTIFICATIONS_REFRESH_EVENT, this.handleNotificationsRefresh);
            window.removeEventListener(NOTIFICATIONS_RESET_EVENT, this.handleNotificationsReset);
        }
    }
    render() {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
}
RouteHandler.loadPage = () => {
    var _a;
    (_a = RouteHandler.__singletonRef) === null || _a === void 0 ? void 0 : _a.handleRouteLanding();
};
RouteHandler.propTypes = {
    isReactApp: prop_types_1.default.bool,
};
RouteHandler.defaultProps = {
    isReactApp: false,
};
const mapStateToProps = (state) => ({
    context: state.main.context,
    notificationsState: state.main.notifications,
});
const mapDispatchToProps = (dispatch) => ({
    setCpParams: (data) => dispatch(reducers_main_reducer_1.actions.setCpParams(data)),
    setContextData: (newData) => dispatch(reducers_main_reducer_1.actions.setContextData(newData)),
    checkCPAndSetZones: (data) => dispatch(reducers_main_reducer_1.actions.checkCPAndSetZones(data)),
    setUserPqInfo: (data) => dispatch(reducers_main_reducer_1.actions.setUserPqInfo(data)),
    setUserCompatibilities: (data) => dispatch(reducers_main_reducer_1.actions.setUserCompatibilities(data)),
    setUserPromotions: (data) => dispatch(reducers_main_reducer_1.actions.setUserPromotions(data)),
    setUserBundle: (data) => dispatch(reducers_main_reducer_1.actions.setUserBundle(data)),
    setUserDefinitions: (data) => dispatch(reducers_main_reducer_1.actions.setUserDefinition(data)),
    setUserLgInfo: (data) => dispatch(reducers_main_reducer_1.actions.setUserLgInfo(data)),
    setUserPoInfo: (data) => dispatch(reducers_main_reducer_1.actions.setUserPoInfo(data)),
    setUserRecom: (data) => dispatch(reducers_main_reducer_1.actions.setUserRecom(data)),
    setCustomer: (data) => dispatch(reducers_main_reducer_1.actions.setCustomerInfo(data)),
    addNotifications: (data) => dispatch(reducers_main_reducer_1.actions.addNotifications(data)),
});
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(RouteHandler);
//# sourceMappingURL=index.js.map